// extracted by mini-css-extract-plugin
export default {"Modal":"style_Modal__shI+U","visible":"style_visible__6EUSO","content":"style_content__uZz-F","groupInput":"style_groupInput__e5i56","btnInput":"style_btnInput__66jGM"};